<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <span id="top">
        <el-row class="chevereBanner">
            <el-col :xs="24" >
                <vue-particles style="height:100vh;"
                    color="#dedede"
                    :particleOpacity="0.7"
                    :particlesNumber="50"
                    shapeType="circle"
                    :particleSize="3"
                    linesColor="#dedede"
                    :linesWidth="0"
                    :lineLinked="true"
                    :lineOpacity="0.7"
                    :linesDistance="150"
                    :moveSpeed="4"
                    :hoverEffect="true"
                    hoverMode="grab"
                    :clickEffect="true"
                    clickMode="push"
                >
                </vue-particles>
            </el-col>
            <img class="CanvasImg" src="@/../public/assets/images/identidad/1.png" alt="ChevereTech" title="ChevereTech">
            <h1 v-if="this.nombreServicio" class="CanvasText">{{this.nombreServicio}}</h1>
            <h1 v-else class="CanvasText">¡Soluciones Informáticas a la medida!</h1>
            <span id="contact" class="hidden-md-and-down">
                <el-row :gutter="20">
                    <el-col :xs="12" ><h1 style="font-size: 35px !important" class="chevere-title">¡Contáctanos!</h1></el-col>
                    <el-col :xs="12" >
                        <font-awesome-icon icon="user" />
                        <input @focus="placeholderName = '' "
                                @blur="placeholderName = '¿Como te llamas?'" class="input-chevere"  :placeholder="this.placeholderName" v-model="name">
                    </el-col>
                    <el-col :xs="12" >
                        <font-awesome-icon icon="phone" />
                        <input @focus="placeholderTlf = '' "
                            @blur="placeholderTlf = '¿Tienes un número de teléfono? (opcional)'" class="input-chevere"  :placeholder="this.placeholderTlf"  v-model="phone">
                    </el-col>                
                </el-row>
                <el-row :gutter="20">                    
                    <el-col :xs="12" >
                        <font-awesome-icon icon="envelope" />
                        <input @focus="placeholderMail = '' "
                                @blur="placeholderMail = 'Déjanos tu correo para poder responderte'" class="input-chevere"  :placeholder="this.placeholderMail" v-model="email" type="email" >
                    </el-col>                
                </el-row>
                <el-row :gutter="20">
                    <el-col :xs="12" >
                        <font-awesome-icon icon="comment" />
                        <textarea @focus="placeholderHist = '' "
                                @blur="placeholderHist = 'Ahora, ¡cuentanos tu historia!'" class="input-chevere" :placeholder="this.placeholderHist" v-model="problem"></textarea>
                    </el-col>
                    <el-col :xs="12" >
                        <br>
                        <el-button class="chevere-send" @click="SendMail()" type="primary" icon="el-icon-send">¡Enviar!</el-button>
                    </el-col>                
                </el-row>
            </span>
        </el-row>        
    </span>
</template>

<script>
import axios from 'axios';

export default {
    name: "banner",
    data () {
    return {
        /*formulario */
        name: null,
        phone: null,
        dir: null,
        email: null,
        problem: null,
        message:null,
        errors: [],
        /*fin formulario */
        placeholderName : '¿Como te llamas?',
        placeholderTlf : '¿Tienes un número de teléfono? (opcional)',
        placeholderMail : 'Déjanos tu correo para poder responderte',
        placeholderHist : 'Ahora, ¡cuentanos tu historia!'
        }
    }, 
    methods :{
        async SendMail () { 
            this.$message({
                message: 'Su mensaje esta siendo enviado, porvavor sea paciente, gracias.',
                type: 'info'
            });   
            if( this.dir === null)
            {
                this.dir = "no especificado"
            }       
            if( this.phone === null)
            {
                this.phone = "no especificado"
            }   
            if( this.name === null)
            {
                this.message = "Porfavor necesitamos que nos diga su nombre para saber como llamarlo"
                this.failure()
                return
            }
            if( this.email === null)
            {
                this.message = "Tiene que dejar su correo para poder comunicarnos con usted"
                this.failure()
                return
            }
            if( this.problem === null)
            {
                this.message = "Si no nos dice que problema tiene, no podremos darle una solución"
                this.failure()
                return
            }
            const params = new URLSearchParams();
            params.append('name', this.name);
            params.append('phone', this.phone);
            params.append('dir', this.dir);
            params.append('email', this.email);
            params.append('problem', this.problem);            
            
            await axios.post('https://mails-api.herokuapp.com/api/SendMail', params);
            
            this.success ();
        },
        failure () {            
            this.$message.error(this.message);
        },
        success () {
            this.$message({
            message: 'Su mensaje ha sido enviado, nos pondremos en contacto con usted lo más pronto posible.',
            type: 'success'
            });
            this.name= null;
            this.phone= null;
            this.dir= null;
            this.email= null;
            this.problem= null;
        }
    },
    props: {
        nombreServicio: {
            required: false
        }        
    }
}
</script>

<style scoped>
.chevereBanner{
    height: 100vh;
    background-image: linear-gradient(to right, #300f6e , #550d77);
    background-size: cover;
}
.CanvasImg {
  position: absolute;
  top: 45%;
  left: 30%;
  transform: translate(-50%, -50%);
  color: white;
  width: 50%;
}

.CanvasText {
  position: absolute;
  top: 60%;
  left: 30%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
}

.input-chevere{
    background-color: transparent;
    color: white;
    border: none;   
    border-bottom: 1px solid #ffffff;
    border-radius: 0;
    outline: none;
    height: 3rem;
    width: 80%;
    font-size: 16px;
    margin: 0 0 8px 0;
    margin-left: 0px;
    padding: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    -webkit-transition: border .3s, -webkit-box-shadow .3s;
    transition: border .3s, -webkit-box-shadow .3s;
    transition: box-shadow .3s, border .3s;
    transition: box-shadow .3s, border .3s, -webkit-box-shadow .3s;
    margin-top: 2%;
    margin-left: 1%;
    padding-right: 2%;
}

#contact{
    max-width: 35%;
    max-height: 100vh;
    color: white;
    position: absolute;
    top: 20%;
    left: 60%;
    margin-bottom: 15px;
    background:rgba(255, 255, 255,0.1);
}

.el-row{
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
}

::placeholder{
    color:white;
}

.input-chevere:focus {
  border-bottom: 3px solid rgb(211,18,130);  
}

.chevere-send{
    background-color: rgb(13,6,36);
    margin-bottom: 15px;
    border: 3px solid rgb(13,6,36);
}

.chevere-send:hover{
    background-color: rgb(59,14,116);
    border: 3px solid rgb(59,14,116);
}

@media only screen and (max-width: 1150px) {
  .CanvasImg{
      width:70%;
      left: 50%;
  }  
  .CanvasText{
      left: 50%;
  }
}
</style>





// WEBPACK FOOTER //
// src/sections/Banner.vue